import { operationListQuerySchema } from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import { OperationsPage } from '@/features/operations/operations-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/operations` — liste des opérations commerciales (`02` §10). La création
 * et l'édition vivent sur leurs propres routes (`/operations/nouvelle`,
 * `/operations/$id`) : plus de dialogue.
 */
export const operationsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/operations',
  validateSearch: (search: Record<string, unknown>) => operationListQuerySchema.parse(search),
  component: OperationsPage,
});
